import { Hymn } from 'models/Hymn';
import React, { useState } from 'react';
import HymnDetails from './HymnDetails';
import './HymnRow.scss';
import ToggleButton from './ToggleButton';

interface HymnRowProps {
  hymn: Hymn;
  isEven: boolean;
}

function HymnRow({ hymn, isEven }: HymnRowProps) {
  const [expanded, setExpanded] = useState<boolean>(false);
  const toggleExpanded = () => setExpanded(!expanded);
  const plusOrMinus = expanded ? '-' : '+';
  return (
    <>
      <tr style={{ backgroundColor: isEven ? '#f9f9f9' : 'white' }}>
        <td>
          <ToggleButton onClick={toggleExpanded}>{plusOrMinus}</ToggleButton>
        </td>
        <td>{hymn.number}</td>
        <td>{hymn.title}</td>
        <td>{hymn.tune}</td>
      </tr>
      {expanded && <HymnDetails hymn={hymn} />}
    </>
  );
}

export default HymnRow;
